import Map from "@commons/Map";
import { usePage } from "@hooks/usePage";
import { CircularProgress } from "@mui/material";
import { useGetCollarsGeoJson } from "@services/device/collar/getGeoJson";
import type { CollarGeoJsonProperties } from "@services/device/collar/getGeoJson/type";
import CollarPopup from "./CollarPopup";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { usePermissions } from "@hooks/usePermissions";

function MapCollar({ filters }: { filters: string }) {
  const { openModal } = usePage();
  const { can } = usePermissions();

  const { data, isLoading, error } = useGetCollarsGeoJson(filters);

  useEffect(() => {
    if (error) {
      toast.error("Erro ao carregar os Rastreadores");
    }
  }, [error]);

  const canCreateCollar = can("create", "collars");

  return (
    <div className="w-full h-[calc(100vh-12rem)] flex flex-col gap-6">
      <div className="flex-1 bg-white rounded-lg shadow-md p-4 min-h-0">
        {isLoading ? (
          <CircularProgress />
        ) : (
          <>
            <Map.Root>
              {canCreateCollar && (
                <Map.Button onClick={() => openModal("newCollar")}>
                  Novo Rastreador
                </Map.Button>
              )}
              <Map.Display<CollarGeoJsonProperties>
                geoJsonData={data}
                popupComponent={CollarPopup}
              />
            </Map.Root>
          </>
        )}
      </div>
    </div>
  );
}
export default MapCollar;
